// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationGender } from './priorAuthorizationGender.js';
import type { PriorAuthorizationPatientAddress } from './priorAuthorizationPatientAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient {
    'address': PriorAuthorizationPatientAddress | null;
    'birthDate': Moment | null;
    'email'?: string | null;
    'firstName': string;
    'gender': PriorAuthorizationGender;
    'lastName': string;
    'middleName'?: string | null;
    'mobile'?: string | null;
    'phone'?: string | null;
    'suffix'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PriorAuthorizationPatientAddress"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "Date"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "PriorAuthorizationGender"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "mobile",
            "baseName": "mobile",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient.attributeTypeMap;
    }
}
